/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * item object
 * @export
 * @interface GetKillmailsKillmailIdKillmailHashItemsItem
 */
export interface GetKillmailsKillmailIdKillmailHashItemsItem {
    /**
     * flag integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItemsItem
     */
    flag: number;
    /**
     * item_type_id integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItemsItem
     */
    itemTypeId: number;
    /**
     * quantity_destroyed integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItemsItem
     */
    quantityDestroyed?: number;
    /**
     * quantity_dropped integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItemsItem
     */
    quantityDropped?: number;
    /**
     * singleton integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashItemsItem
     */
    singleton: number;
}

/**
 * Check if a given object implements the GetKillmailsKillmailIdKillmailHashItemsItem interface.
 */
export function instanceOfGetKillmailsKillmailIdKillmailHashItemsItem(value: object): value is GetKillmailsKillmailIdKillmailHashItemsItem {
    if (!('flag' in value) || value['flag'] === undefined) return false;
    if (!('itemTypeId' in value) || value['itemTypeId'] === undefined) return false;
    if (!('singleton' in value) || value['singleton'] === undefined) return false;
    return true;
}

export function GetKillmailsKillmailIdKillmailHashItemsItemFromJSON(json: any): GetKillmailsKillmailIdKillmailHashItemsItem {
    return GetKillmailsKillmailIdKillmailHashItemsItemFromJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashItemsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKillmailsKillmailIdKillmailHashItemsItem {
    if (json == null) {
        return json;
    }
    return {
        
        'flag': json['flag'],
        'itemTypeId': json['item_type_id'],
        'quantityDestroyed': json['quantity_destroyed'] == null ? undefined : json['quantity_destroyed'],
        'quantityDropped': json['quantity_dropped'] == null ? undefined : json['quantity_dropped'],
        'singleton': json['singleton'],
    };
}

export function GetKillmailsKillmailIdKillmailHashItemsItemToJSON(json: any): GetKillmailsKillmailIdKillmailHashItemsItem {
    return GetKillmailsKillmailIdKillmailHashItemsItemToJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashItemsItemToJSONTyped(value?: GetKillmailsKillmailIdKillmailHashItemsItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flag': value['flag'],
        'item_type_id': value['itemTypeId'],
        'quantity_destroyed': value['quantityDestroyed'],
        'quantity_dropped': value['quantityDropped'],
        'singleton': value['singleton'],
    };
}

